import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
export function Locations() {
  const locations = [{
    title: 'Howell Showroom & Main Service Center',
    address: '222 W Grand River Ave, Howell, MI 48843',
    phone: '517-545-7772',
    phoneLink: 'tel:5175457772'
  }, {
    title: 'Ann Arbor Satellite Office',
    address: '2723 South State St, Suite 150, Ann Arbor, MI 48104',
    phone: '734-887-6556',
    phoneLink: 'tel:7348876556'
  }, {
    title: 'Novi Satellite Office',
    address: '39555 Orchard Hill Place, Suite 600, Novi, MI 48375',
    phone: '248-924-9899',
    phoneLink: 'tel:2489249899'
  }];
  return <section className="py-20 bg-slate-50 border-t border-slate-200" data-id="element-181">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-182">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-183">
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900 mb-6" data-id="element-184">
            Commercial Glass Near Howell, Ann Arbor, Novi & Southeast Michigan
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-185">
            Kosin’s Glass serves commercial glass clients across Southeast
            Michigan and Michigan, including Howell, Ann Arbor, Novi, Brighton,
            Fenton, Hartland, Fowlerville, Northville, Lansing, East Lansing,
            Grand Blanc, Webberville, Williamston, Livonia, Milford, Pinckney,
            Whitmore Lake, Wixom, Oakland County, Livingston County, Ingham
            County, Washtenaw County, Wayne County and the greater Detroit metro
            area. Select larger commercial glazing projects may be available
            outside Michigan depending on scope.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-186">
          {locations.map((loc, idx) => <div key={idx} className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm" data-id="element-187">
              <h3 className="kosins-heading text-2xl text-neutral-900 mb-4" data-id="element-188">
                {loc.title}
              </h3>
              <div className="space-y-3" data-id="element-189">
                <div className="flex items-start gap-3 text-slate-600" data-id="element-190">
                  <MapPin className="w-5 h-5 text-primary-600 shrink-0 mt-0.5" data-id="element-191" />
                  <span className="text-sm" data-id="element-192">{loc.address}</span>
                </div>
                <div className="flex items-center gap-3 text-slate-600" data-id="element-193">
                  <Phone className="w-5 h-5 text-primary-600 shrink-0" data-id="element-194" />
                  <a href={loc.phoneLink} className="text-sm font-semibold hover:text-primary-600 transition-colors" data-id="element-195">
                    {loc.phone}
                  </a>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-navy-900 rounded-xl p-8 max-w-2xl mx-auto text-center text-white" data-id="element-196">
          <div className="flex justify-center mb-4" data-id="element-197">
            <Clock className="w-8 h-8 text-primary-400" data-id="element-198" />
          </div>
          <h3 className="kosins-heading text-2xl text-white mb-4" data-id="element-199">
            Business Hours
          </h3>
          <div className="space-y-2 text-slate-300" data-id="element-200">
            <p data-id="element-201">Monday–Friday: 8:00 a.m. to 5:00 p.m.</p>
            <p data-id="element-202">Saturday: 9:00 a.m. to 3:00 p.m.</p>
            <p className="text-slate-400" data-id="element-203">Sunday: Closed</p>
          </div>
        </div>
      </div>
    </section>;
}